import React from 'react';
import '../assets/styles/login.css'

function Login(props) {

  return (props.trigger) ? (
    <div className='login-tictactoe'>
      <div className='sub-login-tictactoe'>
        <div>
          <h1>Enter a Player</h1>
          <div>
            <input
              name='playerOne'
              onChange={props.handleChange}
              value={props.players.playerOne}
              className="playerLogin-tictactoe"
              type='text'
              placeholder="enter a player1"

            />
          </div>
          <div>
            <input
              name='playerTwo'
              onChange={props.handleChange}
              value={props.players.playerTwo}
              className="playerLogin-tictactoe"
              type='text'
              placeholder="enter a player2"

            />
          </div>
          <button
            onClick={props.playTheGame}
            className="startBtn-tictactoe" >Play The Game</button>
        </div>
        {props.children}
      </div>
    </div>
  ) : '';
}


export default Login;